import React from "react";
import Icon from "./img/gradient-loader.png";
import "./style.scss";

const Loader_AB_2771 = ({ width = 75, height = 75, className = "" }) => {
    return (
        <div className={`loader_ab-container ${className}`} style={{ width: `${width}px`, height: `${height}px` }}>
            <img src={Icon} className="loader_ab" />
        </div>
    );
};

export default Loader_AB_2771;
